import React from 'react';
import { useZunelo } from '../../context/ZuneloContext';
import { DAILY_CONFIG_DATA } from '../../config/uiConfig';
import { DailyService } from '../../services/dailyService';
import { Modal, Button } from '../../ui/common';

export const DailyConfirmModal: React.FC = () => {
  const {
    isDailyConfirmOpen,
    setIsDailyConfirmOpen,
    dailyGroups,
    previewOverride,
    sendDaily,
  } = useZunelo();

  if (!isDailyConfirmOpen) return null;

  const composerMarkdown =
    previewOverride !== null
      ? previewOverride
      : DailyService.formatDailyComposerMarkdown(dailyGroups, DAILY_CONFIG_DATA.channel);
  const slackPreview = DailyService.composerMarkdownToSlackMrkdwn(composerMarkdown);

  return (
    <Modal isOpen={isDailyConfirmOpen} onClose={() => setIsDailyConfirmOpen(false)} width={480}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <div style={{ padding: '16px 18px', borderBottom: 'none' }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 2, color: 'var(--z-text)' }}>
            Enviar daily a {DAILY_CONFIG_DATA.channel}
          </div>

          <div style={{ fontSize: 12, color: 'var(--z-dim)' }}>
            Así se verá el mensaje para todo el equipo
          </div>
        </div>

        {/* Message preview body — uses the edited preview, not raw checklist lines */}
        <div
          data-testid="daily-confirm-preview"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto',
            padding: '16px 18px',
            fontSize: 13,
            color: 'var(--z-text-3)',
            lineHeight: 1.6,
            whiteSpace: 'pre-wrap',
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          {slackPreview}
        </div>

        {/* Action buttons */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, padding: '14px 18px', borderTop: 'none' }}>
          <Button variant="ghost" size="sm" onClick={() => setIsDailyConfirmOpen(false)}>
            Cancelar
          </Button>
          <Button variant="primary" size="sm" onClick={sendDaily}>
            Confirmar y enviar
          </Button>
        </div>
      </div>
    </Modal>
  );
};
